import React, { useEffect, useState } from 'react';
import {
  Container, Typography, Box, TextField, Button, Alert,
  FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminVehicleSeriesForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;

  const [name, setName] = useState('');
  const [vehicleModelId, setVehicleModelId] = useState('');
  const [selectedBrandId, setSelectedBrandId] = useState('');
  const [yearStart, setYearStart] = useState('');
  const [yearEnd, setYearEnd] = useState('');
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    axiosInstance.get('/vehiclebrands').then(res => setBrands(res.data)).catch(() => {});
    if (id) {
      axiosInstance.get(`/vehicleseries/${id}`)
        .then(async res => {
          setName(res.data.name);
          setVehicleModelId(res.data.vehicleModelId);
          setYearStart(res.data.yearStart);
          setYearEnd(res.data.yearEnd || '');
          // Marka yükle, sonra modelleri yükle
          if (res.data.brandId) {
            setSelectedBrandId(res.data.brandId);
            const mRes = await axiosInstance.get(`/vehiclemodels?brandId=${res.data.brandId}`);
            setModels(mRes.data);
          }
        })
        .catch(() => setError('Seri bilgileri alınamadı.'));
    }
  }, [id]);

  const handleBrandChange = async (val) => {
    setSelectedBrandId(val);
    setVehicleModelId('');
    if (val) {
      const res = await axiosInstance.get(`/vehiclemodels?brandId=${val}`);
      setModels(res.data);
    } else {
      setModels([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('adminToken');
    const data = {
      name, vehicleModelId,
      yearStart: Number(yearStart),
      yearEnd: yearEnd ? Number(yearEnd) : null
    };
    try {
      if (isEdit) {
        await axiosInstance.put(`/vehicleseries/${id}`, data, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } else {
        await axiosInstance.post('/vehicleseries', data, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      navigate('/admin/vehicles/series');
    } catch (err) {
      setError('Kayıt başarısız: ' + (err.response?.data || err.message));
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h5" fontWeight={700} sx={{ mb: 3 }}>
          {isEdit ? 'Seriyi Düzenle' : 'Yeni Seri Ekle'}
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth required margin="normal">
            <InputLabel>Marka</InputLabel>
            <Select label="Marka" value={selectedBrandId} onChange={e => handleBrandChange(e.target.value)}>
              {brands.map(b => <MenuItem key={b.id} value={b.id}>{b.name}</MenuItem>)}
            </Select>
          </FormControl>
          <FormControl fullWidth required margin="normal" disabled={!selectedBrandId}>
            <InputLabel>Model</InputLabel>
            <Select label="Model" value={vehicleModelId} onChange={e => setVehicleModelId(e.target.value)}>
              {models.map(m => <MenuItem key={m.id} value={m.id}>{m.name}</MenuItem>)}
            </Select>
          </FormControl>
          <TextField label="Seri / Nesil Adı" fullWidth required margin="normal"
            value={name} onChange={e => setName(e.target.value)}
            helperText='Örn: "Clio 4", "Megane 3", "Duster Facelift"' />
          <TextField label="Başlangıç Yılı" fullWidth required margin="normal" type="number"
            value={yearStart} onChange={e => setYearStart(e.target.value)} />
          <TextField label="Bitiş Yılı (boş = günümüz)" fullWidth margin="normal" type="number"
            value={yearEnd} onChange={e => setYearEnd(e.target.value)} />
          <Box sx={{ display: 'flex', gap: 2, mt: 2 }}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              {isEdit ? 'Güncelle' : 'Oluştur'}
            </Button>
            <Button variant="outlined" fullWidth onClick={() => navigate('/admin/vehicles/series')}>
              İptal
            </Button>
          </Box>
        </form>
      </Box>
    </Container>
  );
};

export default AdminVehicleSeriesForm;
